import { UniqueAad } from 'entities/AADGroup/interfaces';
import { BranchEditing } from 'entities/Branches/interfaces';
import {
  CLEAR_BRANCH_STATE,
  DELETE_BRANCH_ERROR,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  FORCE_SAVE_BRANCH_SET,
  GET_BRANCH_ERROR,
  GET_BRANCH_REQUEST,
  GET_BRANCH_SUCCESS,
  GET_MESSAGE_CAUSE_ERROR,
  GET_MESSAGE_CAUSE_REQUEST,
  GET_MESSAGE_CAUSE_SUCCESS,
  GET_UNIQUE_AAD_ERROR,
  GET_UNIQUE_AAD_REQUEST,
  GET_UNIQUE_AAD_SUCCESS,
  POST_NEW_BRANCH_ERROR,
  POST_NEW_BRANCH_REQUEST,
  POST_NEW_BRANCH_SUCCESS,
  POST_SEND_TEST_MESSAGE_ERROR,
  POST_SEND_TEST_MESSAGE_REQUEST,
  POST_SEND_TEST_MESSAGE_SUCCESS,
  PUT_BRANCH_ERROR,
  PUT_BRANCH_REQUEST,
  PUT_BRANCH_SUCCESS,
  SET_SAVE_BRANCH_SET,
} from './constants';

export const getBranchRequest = (id: string) => ({
  type: GET_BRANCH_REQUEST,
  payload: id,
});

export const getBranchError = (error: Error | null) => ({
  type: GET_BRANCH_ERROR,
  payload: error,
});

export const getBranchSuccess = (locations: BranchEditing) => ({
  type: GET_BRANCH_SUCCESS,
  payload: locations,
});

export const getUniqueAadRequest = (ids: string[]) => ({
  type: GET_UNIQUE_AAD_REQUEST,
  payload: ids,
});

export const getUniqueAadError = (error: Error | null) => ({
  type: GET_UNIQUE_AAD_ERROR,
  payload: error,
});

export const getUniqueAadSuccess = (obj: UniqueAad[]) => ({
  type: GET_UNIQUE_AAD_SUCCESS,
  payload: obj,
});

export const putBranchRequest = (branch: BranchEditing) => ({
  type: PUT_BRANCH_REQUEST,
  payload: branch,
});

export const putBranchError = (error: Error | null) => ({
  type: PUT_BRANCH_ERROR,
  payload: error,
});

export const putBranchSuccess = () => ({
  type: PUT_BRANCH_SUCCESS,
});

export const postNewBranchRequest = (branch: BranchEditing) => ({
  type: POST_NEW_BRANCH_REQUEST,
  payload: branch,
});

export const postNewBranchError = (error: Error | null) => ({
  type: POST_NEW_BRANCH_ERROR,
  payload: error,
});

export const postNewBranchSuccess = () => ({
  type: POST_NEW_BRANCH_SUCCESS,
});

export const deleteBranchSuccess = () => ({
  type: DELETE_BRANCH_SUCCESS,
});

export const deleteBranchRequest = (id: number, isDeleted: boolean) => ({
  type: DELETE_BRANCH_REQUEST,
  payload: id,
  isDeleted,
});

export const deleteBranchError = (error: Error | null) => ({
  type: DELETE_BRANCH_ERROR,
  payload: error,
});

export const clearBranchState = () => ({
  type: CLEAR_BRANCH_STATE,
});

export const saveBranch = (save: boolean) => ({
  type: SET_SAVE_BRANCH_SET,
  payload: save,
});

export const forceSaveBranch = (forceSave: boolean) => ({
  type: FORCE_SAVE_BRANCH_SET,
  payload: forceSave,
});

export const postSendTestMessageRequest = (body: { phoneNumber: any; branchId: number }) => ({
  type: POST_SEND_TEST_MESSAGE_REQUEST,
  payload: body,
});

export const postSendTestMessageSuccess = () => ({
  type: POST_SEND_TEST_MESSAGE_SUCCESS,
});

export const postSendTestMessageError = (error: any) => ({
  type: POST_SEND_TEST_MESSAGE_ERROR,
  payload: error,
});

export const getMessageCauseRequest = () => ({
  type: GET_MESSAGE_CAUSE_REQUEST,
});

export const getMessageCauseSuccess = (response: any) => ({
  type: GET_MESSAGE_CAUSE_SUCCESS,
  payload: response,
});

export const getMessageCauseError = (error: any) => ({
  type: GET_MESSAGE_CAUSE_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof getMessageCauseRequest>
  | ReturnType<typeof getMessageCauseSuccess>
  | ReturnType<typeof getMessageCauseError>
  | ReturnType<typeof postSendTestMessageRequest>
  | ReturnType<typeof postSendTestMessageSuccess>
  | ReturnType<typeof postSendTestMessageError>
  | ReturnType<typeof getUniqueAadRequest>
  | ReturnType<typeof getUniqueAadSuccess>
  | ReturnType<typeof getUniqueAadError>
  | ReturnType<typeof getBranchRequest>
  | ReturnType<typeof getBranchSuccess>
  | ReturnType<typeof getBranchError>
  | ReturnType<typeof putBranchRequest>
  | ReturnType<typeof putBranchError>
  | ReturnType<typeof putBranchSuccess>
  | ReturnType<typeof deleteBranchRequest>
  | ReturnType<typeof deleteBranchSuccess>
  | ReturnType<typeof deleteBranchError>
  | ReturnType<typeof clearBranchState>
  | ReturnType<typeof saveBranch>
  | ReturnType<typeof forceSaveBranch>;
